module.exports = __webpack_public_path__ + "static/img/1.d2a7163.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/1.png
// module id = /4Zx
// module chunks = 0